export default "__VITE_ASSET__8sKJV7oY__"